import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

//获取原型对象上的push函数
const originalPush = Router.prototype.push
//修改原型对象中的push方法
Router.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}

export default new Router({
	routes: [{
			path: '/',
			name: '/',
			meta: {
				isLogin: true
			},
			component: resolve => require(['@/view/Layout.vue'], resolve),
			redirect: '/Home',
			children: [{
				path: 'Home',
				name: '/Home',
				meta: {
					isLogin: true,
					title: '首页',
					isActive: '首页'
				},
				component: resolve => require(['@/view/Home/Index/index.vue'], resolve)
			}, {
				path: 'Payment/List',
				name: '/Payment/List',
				meta: {
					isLogin: true,
					title: '报销列表',
					isActive: '个人报销'
				},
				component: resolve => require(['@/view/Payment/List/index.vue'], resolve)
			}, {
				path: 'Payment/Form',
				name: '/Payment/Form',
				meta: {
					isLogin: true,
					title: '报销详情',
					isActive: '个人报销'
				},
				component: resolve => require(['@/view/Payment/Form/index.vue'], resolve)
			}, {
				path: 'GasStation/PreRegistration',
				name: '/GasStation/PreRegistration',
				meta: {
					isLogin: true,
					title: '预登记情况',
					isActive: '油站扣款'
				},
				component: resolve => require(['@/view/GasStation/PreRegistration/index.vue'], resolve)
			}, {
				path: 'GasStation/Ledger',
				name: '/GasStation/Ledger',
				meta: {
					isLogin: true,
					title: '补票情况',
					isActive: '油站扣款'
				},
				component: resolve => require(['@/view/GasStation/Ledger/index.vue'], resolve)
			}, {
				path: 'GasStation/Index',
				name: '/GasStation/Index',
				meta: {
					isLogin: true,
					title: '油站扣款清单',
					isActive: '油站扣款'
				},
				component: resolve => require(['@/view/GasStation/Index/index.vue'], resolve)
			}, {
				path: 'OnlineBank/Payment',
				name: '/OnlineBank/Payment',
				meta: {
					isLogin: true,
					title: '个人报销',
					isActive: '网银审核'
				},
				component: resolve => require(['@/view/Payment/OnlineBank/index.vue'], resolve)
			}, {
				path: 'VoucherEntry/Payment',
				name: '/VoucherEntry/Payment',
				meta: {
					isLogin: true,
					title: '个人报销',
					isActive: '凭证分录'
				},
				component: resolve => require(['@/view/Payment/VoucherEntry/index.vue'], resolve)
			}, {
				path: 'VoucherEntry/GasStation',
				name: '/VoucherEntry/GasStation',
				meta: {
					isLogin: true,
					title: '油站扣款',
					isActive: '凭证分录'
				},
				component: resolve => require(['@/view/GasStation/VoucherEntry/index.vue'], resolve)
			}, {
				path: 'Base/AccountingCourse',
				name: '/Base/AccountingCourse',
				meta: {
					isLogin: true,
					title: '会计事项表',
					isActive: '配置'
				},
				component: resolve => require(['@/view/SystemSet/AccountingCourse/index.vue'], resolve)
			}, {
				path: 'Base/AccountingCourseClassify',
				name: '/Base/AccountingCourseClassify',
				meta: {
					isLogin: true,
					title: '会计科目表',
					isActive: '配置'
				},
				component: resolve => require(['@/view/SystemSet/AccountingCourseClassify/index.vue'], resolve)
			}, {
				path: 'Base/MatterQuota',
				name: '/Base/MatterQuota',
				meta: {
					isLogin: true,
					title: '额度配置',
					isActive: '配置'
				},
				component: resolve => require(['@/view/SystemSet/MatterQuota/index.vue'], resolve)
			}, {
				path: 'Base/Moa',
				name: '/Base/Moa',
				meta: {
					isLogin: true,
					title: 'MOA配置',
					isActive: '配置'
				},
				component: resolve => require(['@/view/SystemSet/Moa/index.vue'], resolve)
			}, {
				path: 'Base/Department',
				name: '/Base/Department',
				meta: {
					isLogin: true,
					title: '费用部门管理',
					isActive: '配置'
				},
				component: resolve => require(['@/view/SystemSet/Department/index.vue'], resolve)
			}, {
				path: 'Base/ResettingPwd',
				name: '/Base/ResettingPwd',
				meta: {
					isLogin: true,
					title: '重置密码',
					isActive: '配置'
				},
				component: resolve => require(['@/view/SystemSet/ResettingPwd/index.vue'], resolve)
			}, {
				path: 'Base/PersonBankList',
				name: '/Base/PersonBankList',
				meta: {
					isLogin: true,
					title: '员工银行信息',
					isActive: '网银审核'
				},
				component: resolve => require(['@/view/SystemSet/PersonBankList/index.vue'], resolve)
			}, {
				path: 'Base/Role',
				name: '/Base/Role',
				meta: {
					isLogin: true,
					title: '角色管理',
					isActive: '配置'
				},
				component: resolve => require(['@/view/SystemSet/Role/index.vue'], resolve)
			}, {
				path: 'Author',
				name: '/Author',
				meta: {
					isLogin: true,
					title: '工作授权',
					isActive: '基础信息'
				},
				component: resolve => require(['@/view/Author/Index/index.vue'], resolve)
			}, {
				path: 'UpdatePwd',
				name: '/UpdatePwd',
				meta: {
					isLogin: true,
					title: '修改密码',
					isActive: '基础信息'
				},
				component: resolve => require(['@/view/Author/UpdatePwd/index.vue'], resolve)
			}, {
				path: 'Base/TicketTypeList',
				name: '/Base/TicketTypeList',
				meta: {
					isLogin: true,
					title: '导出未付款单据',
					isActive: '运维'
				},
				component: resolve => require(['@/view/SystemSet/TicketTypeList/index.vue'], resolve)
			}, {
				path: 'Log',
				name: '/Log',
				meta: {
					isLogin: true,
					title: '系统日志',
					isActive: '运维'
				},
				component: resolve => require(['@/view/Log/Index.vue'], resolve)
			}, {
				path: 'EmployeeList',
				name: '/EmployeeList',
				meta: {
					isLogin: true,
					title: 'MDM同步记录',
					isActive: '运维'
				},
				component: resolve => require(['@/view/Log/EmployeeList.vue'], resolve)
			},{
				path: 'ESSList',
				name: '/ESSList',
				meta: {
					isLogin: true,
					title: 'ESS同步记录',
					isActive: '运维'
				},
				component: resolve => require(['@/view/Log/ESSList.vue'], resolve)
			},{
				path: 'ClearCache',
				name: '/ClearCache',
				meta: {
					isLogin: true,
					title: '缓存清理',
					isActive: '缓存清理'
				},
				component: resolve => require(['@/view/ClearCache/index.vue'], resolve)
			}, {
				path: 'Log',
				name: '/Log',
				meta: {
					isLogin: true,
					title: '系统日志',
					isActive: '运维'
				},
				component: resolve => require(['@/view/Log/Index.vue'], resolve)
			}, {
				path: 'Invoice/Form',
				name: '/Invoice/Form',
				meta: {
					isLogin: true,
					title: '未请款发票详情',
					isActive: '票据管理'
				},
				component: resolve => require(['@/view/Invoice/Form/index.vue'], resolve)
			}, {
				path: 'Invoice/InvoiceList',
				name: '/Invoice/InvoiceList',
				meta: {
					isLogin: true,
					title: '票据清单',
					isActive: '凭证分录'
				},
				component: resolve => require(['@/view/Payment/InvoiceList/index.vue'], resolve)
			}, {
				path: 'Invoice/List',
				name: '/Invoice/List',
				meta: {
					isLogin: true,
					title: '未请款发票认证',
					isActive: '票据管理'
				},
				component: resolve => require(['@/view/Invoice/List/index.vue'], resolve)
			}],
		},
		{
			path: '/Login',
			name: '/Login',
			meta: {
				title: '登录页',
			},
			component: resolve => require(['@/view/Login/Index/index.vue'], resolve)
		},
		{
			path: '/Portal',
			name: '/Portal',
			meta: {
				title: '门户快速登录',
			},
			component: resolve => require(['@/view/Login/Portal/index.vue'], resolve)
		},
		{
			path: '/xihui/BackdoorUserList',
			name: '/xihui/BackdoorUserList',
			meta: {
				title: '运维界面',
			},
			component: resolve => require(['@/view/Login/UserList/index.vue'], resolve)
		},
		{
			path: '/InvoiceShowDialog',
			name: '/InvoiceShowDialog',
			meta: {
				isLogin: true,
				title: '附件查阅器',
				isActive: '附件查阅器'
			},
			component: resolve => require(['@/view/InvoiceShowDialog/index.vue'], resolve)
		},
		{
			path: '/m/',
			name: '移动端',
			meta: {
				isLogin: true
			},
			component: resolve => require(['@/view/MLayout.vue'], resolve),
			redirect: '/m/Home',
			children: [{
				path: '/m/Home',
				name: '/m/Home',
				meta: {
					isLogin: true,
					title: '首页'
				},
				component: resolve => require(['@/view/Home/Mobile/Index.vue'], resolve)
			}, {
				path: '/m/Payment/List',
				name: '/m/Payment/List',
				meta: {
					isLogin: true,
					title: '个人报销列表',
					isActive: '个人报销'
				},
				component: resolve => require(['@/view/Payment/List/Mobile.vue'], resolve)
			}, {
				path: '/m/Author',
				name: '/m/Author',
				meta: {
					isLogin: true,
					title: '工作授权'
				},
				component: resolve => require(['@/view/Author/Mobile/index.vue'], resolve)
			}, {
				path: '/m/Invoice/List',
				name: '/m/Invoice/List',
				meta: {
					isLogin: true,
					title: '未请款发票认证',
					isActive: '票据管理'
				},
				component: resolve => require(['@/view/Invoice/List/Mobile.vue'], resolve)
			}, {
				path: '/m/Invoice/Form',
				name: '/m/Invoice/Form',
				meta: {
					isLogin: true,
					title: '未请款发票详情',
					isActive: '票据管理'
				},
				component: resolve => require(['@/view/Invoice/Form/Mobile.vue'], resolve)
			}, {
				path: '/m/GasStation/Index',
				name: '/m/GasStation/Index',
				meta: {
					isLogin: true,
					title: '油站扣款清单',
					isActive: '油站扣款'
				},
				component: resolve => require(['@/view/GasStation/Index/Mobile.vue'], resolve)
			}]
		}
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js